module.exports = __webpack_public_path__ + "static/media/relegion_stats.aa8a1af3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new_menu_icons/relegion_stats.svg
// module id = 2716
// module chunks = 0